import React from 'react'
import KeylessCipherTable from './KeylessCipherTable';
import KeylessDecryptionTable from './KeylessDecryptionTable';

const KeylessCipherDecryption = ({ plainText, cipherText, fence, rails, selectedPos }) => {

    var cipherTextArray = cipherText.split("");
    return (
        <div>
            <p style={{ textAlign: "left", fontSize: "20px", fontWeight: "bold", margin: "40px 0 10px 0" }}>Decryption</p>

            <div style={{ textAlign: "left", display: "flex" }}>

                <div style={{ display: "inline" }}>
                    <div className='wrapper'>
                        <KeylessDecryptionTable text={cipherTextArray} fence={fence} rails={rails} selectedPos={selectedPos}></KeylessDecryptionTable>
                    </div>
                    <p style={{ fontSize: 19, display: selectedPos.length !== 0 ? "inline" : "none" }} ><span style={{ fontWeight: "bold" }}>Plain Text :</span>{plainText}</p>
                </div>
            </div>
        </div>
    )
}


KeylessCipherDecryption.defaultProps = {
    rowPositions: []
}

export default KeylessCipherDecryption